import React from 'react';
import { Skeleton } from '@shared/components/ui/shadcn';

/**
 * Skeleton para una línea de producto movido en reubicaciones.
 * Replica la estructura visual del panel derecho mientras carga el detalle del producto.
 */
export const MovedProductItemSkeleton = React.memo(() => {
  return (
    <div
      className="border-b pb-4 last:border-b-0 bg-background border-border"
      data-testid="moved-product-item-skeleton"
    >
      {/* Ubicación de origen - Skeleton de chip */}
      <div className="mb-3">
        <Skeleton className="h-7 w-24 rounded-full bg-hover-press" />
      </div>

      {/* Fila principal - Skeleton de producto y cantidad */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3 flex-1">
          {/* Imagen del producto - Skeleton de avatar */}
          <Skeleton className="w-10 h-10 rounded-full bg-hover-press" />
          <div className="space-y-2 flex-1">
            {/* Nombre del producto - Skeleton de texto */}
            <Skeleton className="h-4 w-44 bg-hover-press" />
            {/* Código del producto - Skeleton de texto secundario */}
            <Skeleton className="h-3 w-28 bg-hover-press" />
          </div>
        </div>

        <div className="flex flex-col items-end space-y-2 ml-4">
          {/* Cantidad movida - Skeleton de cantidad */}
          <Skeleton className="h-5 w-12 bg-hover-press" />
          {/* Stock disponible - Skeleton de texto */}
          <Skeleton className="h-3 w-24 bg-hover-press" />
        </div>
      </div>
    </div>
  );
});

MovedProductItemSkeleton.displayName = 'MovedProductItemSkeleton';
